import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {useNavigate, useParams} from 'react-router-dom';
import { toast } from 'react-toastify';
import {
    CreateEmployeeUser,
    GetServiceById,
    GetEmployeeDetailsByUserId,
    UpdateEmployeeUser
} from '../../../../../reduxToolkit/Employee/EmployeeApi';
import {
    createImgObj,
    getDepartments,
    getRoles,
    getWorkStations,
    uploadNewImage,
    userInfoStatus
} from '../../../../../reduxToolkit/CompanyEmployees/CompanyEmployeesApi';
import {GetAllWorkSchdule, GetZoneTree} from '../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi';
import { GetUserRestriction } from '../../../../../reduxToolkit/restrictions/RestrictionApi';
import { GetHeaders } from '../../../../../reduxToolkit/headers/HeadersApi';
import {
    DeleteItemsApi,
    HardDeleteRecordsByTableAndIds
} from '../../../../../reduxToolkit/Commons/CommonsApi';
import {
    CECO_CODE_NAME,
    CECO_LENGTH,
    EMPLOYEE_DATA,
    EXTRA_DATA,
    isStrongPin,
    PIN_LENGTH,
    SERVICE,
    USER_DATA
} from '../Model/Models';
import {GetSingleUserProvider} from '../../../../../reduxToolkit/Providers/providersApi';
import {PermissionByUser} from '../../../../../reduxToolkit/Vehicle/VehicleApi';
import {wsURL} from '../../../../../Apis/Constants';
import {useSnackbar} from 'notistack';
import PasswordGenerator from "../../../../../Helpers/PasswordGenerator";
import {
    errorMsg,
    isEmailFormat,
    isPhoneFormat,
    isValidLengthDocumentId, validateLengthRange,
    postSessionStorageLoader, validateMinLengthTrimmed
} from '../../../../../Apis/functions';
import {getPhotoPicker, PHOTO_PICKER_MODEL} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import defaultImage from '../../../../../assets/ImagesDefaults/ic-person.svg';
import {accessMethodModel} from '../../../../../enums/accessMethodEnum';
import {TABLES} from '../../../../../Apis/Tables';
import {USER_TYPE_NAME_MODEL} from "../../../../../enums/userTypeEnum";
import { PASSWORD_MIN_LENGTH } from '../../../../../constant/variable';
const EmployeeApp = () => {
    const START_STREAM = 'START_STREAM';
    const CREATE_PRINT_CARD = 'CREATE_PRINT_CARD';
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { id } = useParams();
    const contractorId = useState(sessionStorage.getItem('contractorId'));
    const supplierId = useState(sessionStorage.getItem('providerId'));
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const employeeRoles = useSelector((state) => state?.CompanyEmployeesSlice?.employeeRoles);
    const employeeWorkStations = useSelector((state) => state?.CompanyEmployeesSlice?.employeeWorkStations);
    const { contractStatusList } = useSelector((state) => state?.CompanyEmployeesSlice);
    const employeeDepartments = useSelector((state) => state?.CompanyEmployeesSlice?.employeeDepartments);
    const { headersList } = useSelector((state) => state.headersSlice);
    const { user } = useSelector((state) => state.authenticatioauthennSlice);
    const { getUserRestriction } = useSelector((state) => state?.RestrictionSlice);
    const singleEmployeeWithId = useSelector((state) => state?.CompanyEmployeesSlice?.singleEmployeeWithId);
    const userType = user?.data?.userType?.name;
    const getEmployeeDetailsByUserId = useSelector((state) => state?.EmployeeSlice?.getEmployeeDetailsByUserId);
    const selfieSavedId = getEmployeeDetailsByUserId?.data?.selfie?.id;

    const [newCardModal, setNewCardModal] = useState(false);
    const [imageToUpload, setImageToUpload] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const [workShiftsList, setWorkShiftsList] = useState([]);
    const [customizedList, setCustomizedList] = useState([]);

    const [emptyFields, setEmptyFields] = useState(false);
    const [emptySelfie, setEmptySelfie] = useState(false);
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [isValidPassword, setIsValidPassword ] = useState(true);
    const [isValidDocumentId, setIsValidDocumentId] = useState(true);
    const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
    const [isValidDob, setIsValidDob] = useState(true);
    const [isValidStartDate, setIsValidStartDate] = useState(true);
    const [isValidEndDate, setIsValidEndDate] = useState(true);
    const [isValidPin, setIsValidPin] = useState(true);
    const [isValidCecoCode, setIsValidCecoCode] = useState(true);
    const [extraDataEnabled, setExtraDataEnabled] = useState(false);
    const [steps, setSteps] = useState([]);
    const disabled = false;

    const [selectedImage, setSelectedImage] = useState(null);

    const [selectedReader, setSelectedReader] = useState('');
    const [availableReaders, setAvailableReaders] = useState([]);
    const [fingerprintName, setFingerprintName] = useState('');
    const [capturedFingerprint, setCapturedFingerprint] = useState(null);
    const [fingerprintsList, setFingerprintsList] = useState([]);
    const [updated, setUpdated] = useState(false);
    const [updatedFinger, setUpdatedFinger] = useState(false);
    const [availableCameras, setAvailableCameras] = useState([]);
    const [selectedCamera, setSelectedCamera] = useState('');

    const [loadingProgress, setLoadingProgress] = useState(false);

    const [capturing, setCapturing] = useState(false);
    const [createEmployeeEmail, setCreateEmployeeEmail] = useState(true);
    const [language, setLanguage] = useState('');

    const [takeCamera, setTakeCamera] = useState(false);
    const [selfieSrc, setSelfieSrc] = useState('');

    const [userData, setUserData] = useState({...USER_DATA});
    const [extraData, setExtraData] = useState({...EXTRA_DATA});
    const [employeeData, setEmployeeData] = useState({...EMPLOYEE_DATA});

    const [cardData, setCardData] = useState([]);
    const [cardDataInfo, setCardDataInfo] = useState([]);

    const [selectVehicleForDelete, setSelectVehicleForDelete] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [vehicleData, setVehicleData] = useState();

    const [alldata, setAlldata] = useState('');
    const [cardsList, setCardsList] = useState([]);
    const [documentsList, setDocumentsList] = useState([]);
    const [ProfileImage, setProfileImage] = useState(null);
    const [url2, setUrl2] = useState(null);
    const [showUnlinkBtn, setShowUnlinkBtn] = useState(false);
    const [role, setRole] = useState();
    const [workStation, setWorkStation] = useState();
    const [contractStatus, setContractStatus] = useState();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const websocketRef = useRef(null);
    const [isSocketOpen, setIsSocketOpen] = useState(false);
    const [switchSocket, setSwitchSocket] = useState('');
    const vehicleId = sessionStorage.getItem('vehicleidfordetail');
    const [deletePermitShow, setDeletePermitShow] = useState(false)
    const [vCardShow, setVCardShow] = useState(false);
    const [showPluginWarn, setShowPluginWarn] = useState(false);
    const [currentPrint, setCurrentPrint] = useState(null);
    const [secretModal, setSecretModal] = useState(false);
    const [secretKey, setSecretKey] = useState(null);
    const [generatedPassword, setGeneratedPassword] = useState(null);
    const { passwordGenerator } = PasswordGenerator();

    const [modified, setModified] = useState(0);
    const [modifiedVehicle, setModifiedVehicle] = useState(false);
    const [videoStreamSrc, setVideoStreamSrc] = useState('');
    const [fingerprintSrc, setFingerprintSrc] = useState('');
    const [isPilgrimsValidation, setIsPilgrimsValidation] = useState(false);

    const [photoPicker, setPhotoPicker] = useState({...PHOTO_PICKER_MODEL, preview: defaultImage});
    const fingerName = 'fingerprint.wsq';
    const prevPhotoRef = useRef({
        fileSelected: null,
        selfieSrc: null,
    });

    useLayoutEffect(() => {
        setSteps(id && id != null ? [...STEP_EMPLOYEE_UPDATE(extraDataEnabled)] : [...STEP_EMPLOYEE_CREATE(extraDataEnabled)] )
    }, [extraDataEnabled, t, permission]);

    useEffect(() => {
        let timer;
        if (loadingProgress) {
            timer = setTimeout(() => setLoadingProgress(false), 2000);
        } else {
            clearTimeout(timer);
        }
        return () => clearTimeout(timer);
    }, [loadingProgress]);

    /**
     * init values and list for create ann update employee
     */
    useEffect(() => {
        dispatch(getRoles());
        dispatch(getWorkStations());
        dispatch(getDepartments());
        dispatch(GetAllWorkSchdule());
        dispatch(userInfoStatus());
        dispatch(GetHeaders());
        dispatch(GetZoneTree());
        dispatch(GetUserRestriction()).then(
            ({
                payload: {
                    data: { data, success },
                },
            }) => {
                if (success === true) {
                    let extraDataProperty =
                        userType === USER_TYPE_NAME_MODEL.EMPLOYEE
                            ? data?.extraDataEmployee
                            : userType === USER_TYPE_NAME_MODEL.CONTRACTOR_IN_CHARGE
                                ? data?.extraDataContractor
                                : userType === USER_TYPE_NAME_MODEL.SUPPLIER_IN_CHARGE
                                    ? data?.extraDataSupplier
                                    : null;

                    setExtraDataEnabled(extraDataProperty);
                }
            },
        );
        dispatch(GetServiceById(SERVICE.PILGRIMS)).then(
            ({
                payload: {
                    data: { data, success },
                },
            }) => {
                if (success === true) {
                      setIsPilgrimsValidation(data?.validation)
                }
            },
        );
    }, []);

    /**
     * set value en session storage
     */
    useEffect(() => {
        sessionStorage.setItem('capturing', capturing);
        window.postMessage(
            {
                type: 'sessionStorageChange',
                newValue: capturing,
            },
            '*',
        );
    }, [capturing]);

    let completeChunk;

    /**
     * useEffect for isSocketOpen, switchSocket
     */
    useEffect(() => {
        if (isSocketOpen) {
            if (switchSocket === 'printer') {
                completeChunk = '';

                const imageData = currentPrint;
                const chunkSize = 1000;
                const totalChunks = Math.ceil(imageData.length / chunkSize);

                for (let i = 0; i < totalChunks; i++) {
                    const start = i * chunkSize;
                    const end = (i + 1) * chunkSize;
                    const chunk = imageData.substring(start, end);

                    completeChunk = completeChunk + chunk;
                    websocketRef.current.send(
                        JSON.stringify({
                            message: CREATE_PRINT_CARD,
                            data: chunk,
                            chunkNumber: i + 1,
                            totalChunks: totalChunks,
                        }),
                    );
                }
            }
        }
    }, [isSocketOpen, switchSocket]);

    /**
     * reset setUpdatedFinger to false
     */
    useEffect(() => {
        setUpdatedFinger(false);
    }, []);

    /**
     * update setSelfieSrc with value of image
     */
    useEffect(() => {
        setSelfieSrc(selfieSrc);
    }, [selfieSrc]);

    /**
     * Gets the selfie data and resets the values. Gets the employee details data
     * and sets the values. Gets the provider and persistence values and sets the values.
     */
    useEffect(() => {
        getData();
    }, [id, modified]);

    useEffect(() => {
        if(updated){
            getData();
            setUpdated(false);
        }
    }, [updated]);

    const getData = () => {
        setUpdatedFinger(false);
        if (id) {
            dispatch(GetEmployeeDetailsByUserId(id)).then(
                ({
                     payload: {
                         data: { data },
                     },
                 }) => {
                    setAlldata(data);
                    setEmployeeData((prev) => ({ ...prev, ...data?.employee}));
                    setExtraData(data?.extraData);
                    setUserData((prev) => ({ ...prev, ...data?.user }));
                    setWorkShiftsList(data?.workShifts.map((item) => ({ ...item, new: false })));
                    setCustomizedList(data?.customs?.map((item) => ({ ...item, added: true, new: false })));
                    setFingerprintsList(data?.fingerprints);
                    setCardsList(data?.cards);
                    setDocumentsList(data?.documents);

                    if (data?.selfie) {
                        setProfileImage(data?.selfie.image);
                        setUrl2(`data:image/jpeg;base64,${data?.selfie?.image}`);
                        setPhotoPicker(prev => ({...prev, previewImage: `data:image/jpeg;base64,${data?.selfie?.image}`, id:data?.selfie?.id }))
                    }else{
                        clearImage();
                    }
                    setUpdated(false);
                    setLoadingProgress(false);
                    postSessionStorageLoader(false);
                },
            );
            dispatch(GetSingleUserProvider(id)).then(
                ({
                     payload: {
                         data: { data },
                     },
                 }) => {
                    setShowUnlinkBtn(data?.deviceId);
                },
            );

            getVehiclePermission();
        }
    }


    useEffect(() => {
        if(modifiedVehicle){
            getVehiclePermission();
            setModifiedVehicle(false);
        }
    }, [modifiedVehicle]);

    const getVehiclePermission = () => {
        dispatch(PermissionByUser(id)).then(
            ({
                 payload: {
                     data: { data },
                 },
             }) => {
                setVehicleData(data);
            },
        );
    }

    /**
     * set value for role, work station and contractors
     */
    useEffect(() => {
        setRole(singleEmployeeWithId?.role?.id);
        setWorkStation(singleEmployeeWithId?.zone?.id);
        setContractStatus(singleEmployeeWithId?.status?.id);
    }, [singleEmployeeWithId?.id]);

    /**
     * get step list fo employee create
     * @param boolean extraDataEnabled
     * @returns {string[]}
     * @constructor
     */
    const  STEP_EMPLOYEE_CREATE = (extraDataEnabled) => {
        if (extraDataEnabled){
            return [t('details'), t('other_details'), t('employee_contract'), t('access_rights'), t('take_photography'), t('capture_fingerprint'), t('card'), t('summary')];
        }
        return [t('details'), t('employee_contract'), t('access_rights'), t('take_photography'), t('capture_fingerprint'), t('card'), t('summary')];
    }

    /**
     * get step list fo employee update
     * @param boolean extraDataEnabled
     * @returns {string[]}
     * @constructor
     */
    const  STEP_EMPLOYEE_UPDATE = (extraDataEnabled) => {
        if (extraDataEnabled){
            return [t('details'),t('other_details'),t('employee_contract'),t('take_photography'),t('card'),t('documents'),t('driving_permits'),t('access_rights'),t('fingerprint')];
        }
        return [t('details'),t('employee_contract'),t('take_photography'),t('card'),t('documents'),t('driving_permits'),t('access_rights'),t('fingerprint')];
    }

    useEffect(() => {
        validateEmail();
    }, [userData.email]);

    useEffect(() => {
        validatePhone();
    }, [userData.phoneNumber]);

    useEffect(() => {
        validateDocumentId();
    }, [userData.documentId]);

    useEffect(() => {
        validatePin();
    }, [userData.pin]);

    useEffect(() => {
        validateCecoCode();
    }, [employeeData.cecoCode]);

    useEffect(() => {
        const isValid = validateMinLengthTrimmed(userData.password, {
            minLength: PASSWORD_MIN_LENGTH,
            allowEmpty: true,
        });

        setIsValidPassword(isValid);
    }, [userData.password]);


    /**
     * This function handles changes in the form fields. It updates the 'userData' state by spreading
     * the previous data and updating the specific field (identified by 'name') with the new value from the form input.
     * @param e
     */
    const handleFormChangeUserData = (e) => {
        const { name, value } = e.target;
        setUserData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    /**
     * This function handles changes in the form fields for extra data. It updates the 'extraData' state by spreading the previous data
     * and updating the specific field (identified by 'name') with the new value from the form input.
     * @param e
     */
    const handleFormChangeExtraData = (e) => {
        const { name, value } = e.target;
        setExtraData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    /**
     * This function handles changes in the form fields for employee data. It updates the 'employeeData' state by spreading the previous data
     * and updating the specific field (identified by 'name') with the new value from the form input.
     * @param e
     */
    const handleFormChangeEmployeeData = (e) => {
        let { name, value } = e.target;

        if(name === CECO_CODE_NAME)
            value = value.replace(/\s/g, '');

        setEmployeeData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    /**
     * This function updates the active step in a multi-step process by setting the 'activeStep' state to the provided 'step'.
     * @param step
     */
    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    /**
     * handle to upload the image
     * @param id
     */
    const handleUploadFinger = (id) => {
        if (capturedFingerprint) {
            const body = {
                accessMethod: {
                    id: accessMethodModel.FINGER_PRINT.id,
                },
                user: {
                    id,
                },
                description: fingerprintName,
            };
            dispatch(createImgObj(body)).then(async ({payload: {data: { data, success }}}) => {
                    if (success) {
                        let formData = new FormData();
                        formData.append('id', data.id);
                        formData.append('option', TABLES.USER);
                        formData.append('file', capturedFingerprint, fingerName);

                        dispatch(uploadNewImage(formData)).then(({
                                payload: { data: { success, code } },
                            }) => {
                                if (success === true) {
                                    setUpdated(true);
                                    setUpdatedFinger(true);
                                    setSelectedReader('');
                                    setAvailableReaders([]);
                                    setFingerprintSrc('');
                                    setCapturedFingerprint(null);
                                    setFingerprintName('');
                                    toast.success(t('has_been_created_successfully'));
                                } else {
                                    errorMsg(code)
                                }
                            },
                        );
                    }
                },
            );
        }
    };

    /**
     * handle to create employee
     */
    const handleCreateEmployee = () => {
        const imageProfile = getPhotoPicker(photoPicker);
        if (isPilgrimsValidation && !imageProfile) {
            setEmptyFields(true);
            return;
        }
        const workShifts = workShiftsList.map(({ id, name }) => ({
            id: id,
        }));

        const customs = customizedList
            .filter((element) => element.added === true)
            .map(({ zoneId, zoneName, dayId, from, to }) => ({
                zoneId: zoneId,
                zoneName: zoneName,
                dayId: dayId,
                from: from,
                to: to,
            }));

        const body = {
            employee: {
                employeeId: employeeData.employeeId,
                departmentId: employeeData.departmentId,
                departmentName: employeeDepartments.find((item) => item.id === employeeData?.departmentId)?.name,
                startDate: employeeData.startDate.getTime(),
                endDate:
                    employeeData.endDate === null ? employeeData.startDate.getTime() : employeeData.endDate.getTime(),
                roleId: employeeData.roleId,
                roleName: employeeRoles.find((item) => item.id === employeeData?.roleId)?.name,
                zoneId: employeeData.zoneId,
                zoneName: employeeWorkStations.find((item) => item.id === employeeData?.zoneId)?.name,
                cecoCode: employeeData.cecoCode || null
            },
            extraData: {
                field1: extraData.field1,
                field2: extraData.field2,
                field3: extraData.field3,
                field4: extraData.field4,
                field5: extraData.field5,
                field6: extraData.field6,
                field7: extraData.field7,
                field8: extraData.field8,
                field9: extraData.field9,
                field10: extraData.field10,
                field11: extraData.field11,
                field12: extraData.field12,
                field13: extraData.field13,
                field14: extraData.field14,
                field15: extraData.field15,
            },
            user: {
                dob: userData.dob !== null ? userData.dob.getTime() : null,
                email: userData.email,
                genderId: userData.genderId,
                lastName: userData.lastName,
                name: userData.name,
                phoneNumber: userData.phoneNumber !== null && userData.phoneNumber !== '' ? '+' + userData.phoneNumber : null,
                password: (userData.password.trim() !== '') ? userData.password : passwordGenerator(),
                secondLastName: userData.secondLastName,
                statusId: userData.statusId,
                documentId: userData.documentId,
                pin: userData.pin || null
            },
            customs: customs,
            workShifts: workShifts,
            cards: cardData,
        };

        dispatch(CreateEmployeeUser(body)).then(({payload: {data: { data, success, code }}}) => {
                    if (success === true) {
                        toast.success(t('has_been_created_successfully'));
                        const id = data?.user?.id;

                        if (capturedFingerprint) {
                            const body = {
                                accessMethod: {
                                    id: accessMethodModel.FINGER_PRINT.id,
                                },
                                user: {
                                    id,
                                },
                                description: fingerprintName,
                            };

                            dispatch(createImgObj(body)).then(
                                async ({
                                    payload: {
                                        data: { data, success },
                                    },
                                }) => {
                                    if (success) {
                                        let formData = new FormData();
                                        formData.append('id', data.id);
                                        formData.append('option', TABLES.USER);
                                        formData.append('file', capturedFingerprint, fingerName);

                                        dispatch(uploadNewImage(formData)).then(( { payload: { data: { success } } } ) => {
                                            if (success === true) {
                                                setUpdated(true);
                                                setUpdatedFinger(true);
                                                setSelectedReader('');
                                                setAvailableReaders([]);
                                                setFingerprintSrc('');
                                                setCapturedFingerprint(null);
                                                setFingerprintName('');
                                            }
                                        });
                                    }
                                },
                            );
                        }
                        const imageProfile = getPhotoPicker(photoPicker);
                        if (imageProfile != null && typeof imageProfile != 'undefined') {
                            const body = {
                                accessMethod: {
                                    id: accessMethodModel.FACE_RECOGNITION.id,
                                },
                                user: {
                                    id,
                                },
                                description: 'Face recognition',
                            };
                            dispatch(createImgObj(body)).then(( { payload: { data: { data } } } ) => {
                                let formData = new FormData();
                                formData.append('id', data.id);
                                formData.append('option', TABLES.USER);
                                formData.append('file', imageProfile);
                                dispatch(uploadNewImage(formData));
                            });
                        }

                        setSecretModal(true);
                        setSecretKey(data.user.secret);
                        setGeneratedPassword(userData?.password?.trim() !== "" ? null: body.user.password);//userData?.password === null: Password was generate by the system
                    } else {
                        errorMsg(code)
                    }
                },
            )
            .catch((error) => {
                if (error.response) {
                    const statusCode = error.response.status;
                    if (statusCode === 500) {
                        toast.error(t('server_error'));
                    } else {
                        toast.error(t('unexpected_error'));
                    }
                } else if (error.request) {
                    toast.error(t('network_error'));
                } else {
                    toast.error(t('unexpected_error'));
                }
            });
    };

    /**
     * handle to update employee
     */
    const handleUpdateEmployee = () => {
        const workShifts = workShiftsList.map(({ id, name }) => ({
            id: id, // Cambia el nombre de la propiedad oldPropertyName1 a newPropertyName1
        }));

        const customs = customizedList
            .filter((element) => element.added === true && element.new === true) // Filtra los elementos con la propiedad "added" en true
            .map(({ zoneId, zoneName, dayId, from, to }) => ({
                zoneId: zoneId,
                zoneName: zoneName,
                dayId: dayId,
                from: from,
                to: to,
            }));

        const body = {
            employee: {
                employeeId: employeeData.employeeId,
                departmentId: employeeData.departmentId,
                departmentName: employeeDepartments.find((item) => item.id === employeeData?.departmentId)?.name,
                startDate:
                    typeof employeeData.startDate === 'number'
                        ? employeeData.startDate
                        : employeeData.startDate.getTime(),
                endDate:
                    employeeData.endDate === null
                        ? typeof employeeData.startDate === 'number'
                            ? employeeData.startDate
                            : employeeData.startDate.getTime()
                        : typeof employeeData.endDate === 'number'
                            ? employeeData.endDate
                            : employeeData.endDate.getTime(),
                roleId: employeeData.roleId,
                roleName: employeeRoles.find((item) => item.id === employeeData?.roleId)?.name,
                zoneId: employeeData.zoneId,
                zoneName: employeeWorkStations.find((item) => item.id === employeeData?.zoneId)?.name,
                id: employeeData.id,
                cecoCode: employeeData.cecoCode || null
            },
            extraData: {
                field1: extraData.field1,
                field2: extraData.field2,
                field3: extraData.field3,
                field4: extraData.field4,
                field5: extraData.field5,
                field6: extraData.field6,
                field7: extraData.field7,
                field8: extraData.field8,
                field9: extraData.field9,
                field10: extraData.field10,
                field11: extraData.field11,
                field12: extraData.field12,
                field13: extraData.field13,
                field14: extraData.field14,
                field15: extraData.field15,
                id: extraData.id,
                userId: extraData.userId,
            },
            user: {
                dob:
                    userData.dob === null
                        ? null
                        : typeof userData.dob === 'number'
                            ? userData.dob
                            : userData.dob.getTime(),
                email: userData.email,
                documentId: userData.documentId || null,
                genderId: userData.genderId,
                lastName: userData.lastName,
                name: userData.name,
                phoneNumber:
                    (userData.phoneNumber !== null && userData.phoneNumber !== '')
                        ? userData.phoneNumber[0] === '+'
                            ? userData.phoneNumber
                            : '+' + userData.phoneNumber
                        : null,
                password: userData.password !== '' ? userData.password : null,
                secondLastName: userData.secondLastName,
                statusId: userData.statusId,
                id: userData.id,
                userTypeId: userData.userTypeId,
                pin: userData.pin || null
            },
            customs: customs,
            workShifts: workShifts,
        };

        dispatch(UpdateEmployeeUser(body))
            .then(
                ({
                    payload: {
                        data: { data, success, code },
                    },
                }) => {
                    if (success === true) {

                        if (userData.password) {
                            setSecretModal(true);
                            setSecretKey(data?.user?.secret);
                        }

                        const fileChanged = prevPhotoRef.current.fileSelected !== photoPicker?.fileSelected;
                        const selfieChanged = prevPhotoRef.current.selfieSrc !== photoPicker?.selfieSrc;
                        const imageProfile = getPhotoPicker(photoPicker);

                        if ((fileChanged || selfieChanged) && imageProfile) {
                            handleUploadSelfie(imageProfile);
                            prevPhotoRef.current = {
                                fileSelected: photoPicker?.fileSelected,
                                selfieSrc: photoPicker?.selfieSrc,
                            };
                        } else if (selfieSavedId && !photoPicker?.id) {
                            handleDeleteImageApi(selfieSavedId);
                        } else {
                            toast.success(t('has_been_updated_successfully'));
                            setUpdated(true);
                        }
                    } else {
                        errorMsg(code)
                    }
                },
            )
            .catch((error) => {
                if (error.response) {
                    const statusCode = error.response.status;
                    if (statusCode === 500) {
                        toast.error(t('server_error'));
                    } else {
                        toast.error(t('unexpected_error'));
                    }
                } else if (error.request) {
                    toast.error(t('network_error'));
                } else {
                    toast.error(t('unexpected_error'));
                }
            });
    };

    /**
     * handle to upload selfie
     */
    const handleUploadSelfie = (imageProfile) => {

        if (selfieSavedId) {
            let formData = new FormData();
            formData.append('id', selfieSavedId);
            formData.append('option', TABLES.USER);
            formData.append('file', imageProfile);
            dispatch(uploadNewImage(formData)).then(({payload: {data: { success, code }}}) => {
                if (success === true) {
                    setUpdated(true);
                    setSelectedCamera('');
                    setAvailableCameras([]);
                    setSelfieSrc('');
                    setSelectedImage(null);
                    toast.success(t('has_been_updated_successfully'));
                } else {
                    errorMsg(code)
                }
            });
        } else {
            const body = {
                accessMethod: {
                    id: accessMethodModel.FACE_RECOGNITION.id
                },
                user: {
                    id,
                },
                description: 'Face recognition',
            };
            dispatch(createImgObj(body)).then(({payload: {data: { data }}}) => {

                let formData = new FormData();
                formData.append('id', data.id);
                formData.append('option', TABLES.USER);
                formData.append('file', imageProfile);

                dispatch(uploadNewImage(formData)).then(({payload: {data: { success }}}) => {
                    if (success === true) {
                        setUpdated(true);
                        setSelectedCamera('');
                        setAvailableCameras([]);
                        setSelfieSrc('');
                        setSelectedImage(null);
                        toast.success(t('has_been_updated_successfully'));
                    }
                });
            });
        }
    };

    /**
     * handle for delete vehicle selection
     * @param deleteItem
     */
    const deleteSelectedPermits = () => {
        const body = selectVehicleForDelete;

        dispatch(DeleteItemsApi({ tableName: TABLES.USER_VEHICLE_COMPANY, body })).then(
            ({
                 payload: {
                     data: { success },
                 },
             }) => {
                if (success === true) {
                    setSelectVehicleForDelete([]);
                    setIsAllChecked(false);
                    setModifiedVehicle(true);
                }
            },
        );
    };

    //fingercheck
    const getAvailableReaders = () => { };

    /**
     * handle to validate email
     */
    const validateEmail = () => {
        if(userData.email !== '' && userData.email != null && typeof userData.email != 'undefined'){
            setIsValidEmail(isEmailFormat(userData.email));
        }else{
            setIsValidEmail(true)
        }
    };

    /**
     * handle to validate phone
     */
    const validatePhone = () => {
        if(userData.phoneNumber !== '' && userData.phoneNumber != null && typeof userData.phoneNumber != 'undefined'){
            setIsValidPhoneNumber(isPhoneFormat(userData.phoneNumber));
        }else{
            setIsValidPhoneNumber(true);
        }
    };

    /**
     * handle to validate document id
     */
    const validateDocumentId = () => {
        if(userData.documentId !== '' && userData.documentId != null && typeof userData.documentId != 'undefined'){
            setIsValidDocumentId(isValidLengthDocumentId(userData.documentId));
        }else{
            setIsValidDocumentId(true);
        }
    };

    /**
     * handle to validate pin
     */
    const validatePin = () => {
        if(userData.pin !== '' && userData.pin != null && typeof userData.pin != 'undefined'){
            setIsValidPin(
                validateLengthRange(userData.pin, PIN_LENGTH.MIN, PIN_LENGTH.MAX) &&
                isStrongPin(userData.pin)
            );
        }else{
            setIsValidPin(true);
        }
    };

    /**
     * handle to validate ceco code
     */
    const validateCecoCode = () => {
        if(employeeData.cecoCode !== '' && employeeData.cecoCode != null && typeof employeeData.cecoCode != 'undefined'){
            setIsValidCecoCode(validateLengthRange(employeeData.cecoCode, CECO_LENGTH.MIN, CECO_LENGTH.MAX));
        }else{
            setIsValidCecoCode(true);
        }
    };

    /**
     * hadle for checked all box in employee card
     * @param e
     */
    const handleDeleteAll = (e) => {
        setIsAllChecked(e.target.checked);
        if (e.target.checked) {
            const selectAllIds = vehicleData?.map((item) => {
                return item?.id;
            });
            setSelectVehicleForDelete(selectAllIds);
        } else {
            setSelectVehicleForDelete([]);
        }
    };

    /**
     * handle for checked vehicle
     * @param e
     */
    const handleCheckboxChangeVehicle = (e) => {
        if (e.target.checked) {
            setSelectVehicleForDelete([...selectVehicleForDelete, e.target.id]);
        } else {
            setSelectVehicleForDelete(selectVehicleForDelete.filter((removeId) => removeId !== e.target.id));
        }
    };

    /**
     * handle for close modal
     */
    const handleCloseModal = () => {
        setCapturing(false);
        setUpdatedFinger(true);
    };

    /**
     * handle for reset extra data
     */
    const handleClearExtraData = () => {
        setExtraData({...EXTRA_DATA});
    }

    /**
     * handle for reset extra data
     */
    const handleClearUserData = () => {
        setUserData({...USER_DATA});
        setIsValidEmail(true);
        setIsValidDocumentId(true);
        setIsValidPhoneNumber(true);
        setIsValidDob(true);
        setIsValidPin(true);
        setIsValidCecoCode(true);
        setEmptyFields(false);
    }


    /**
     * handle to validation first step in create employee
     */
    const handleValidationStepDetails = () => {
        if (
            userData.isValid() &&
            isValidEmail &&
            isValidPhoneNumber &&
            isValidDob &&
            isValidDocumentId &&
            isValidPin &&
            isValidPassword
        ) {
            setActiveStep((prevStep) => prevStep + 1);
            setEmptyFields(false);
        } else {
            setEmptyFields(true);
        }
    }

    /**
     * handle to validation second step in create employee
     */
    const handleValidationContract = () => {
        const employeeValid = employeeData?.isValid(isPilgrimsValidation);

        if (employeeValid &&
            isValidStartDate &&
            isValidEndDate &&
            isValidCecoCode
        ) {
            setActiveStep((prevStep) => prevStep + 1);
            setEmptyFields(false);
        } else {
            setEmptyFields(true);
        }
    };

    /**
     * handle to validation finger in create employee
     */
    const handleValidationFinger = () => {
        if (selectedReader === '' || (selectedReader !== '' && fingerprintName !== '')) {
            setActiveStep((prevStep) => prevStep + 1);
            setEmptyFields(false);
        } else {
            setEmptyFields(true);
        }
    };

   const isSelfieValid =
    !!photoPicker?.selfieSrc ||
    !!photoPicker?.srcSelected ||
    !!photoPicker?.previewImage;

    useEffect(() => {
        if (isSelfieValid) {
            setEmptySelfie(false);
        }
    }, [isSelfieValid]);

    /**
     * handle to validation selfie in create employee
     */
    const handleValidationSelfie = () => {
        if (isPilgrimsValidation) {
            if (isSelfieValid) {
                setActiveStep((prevStep) => prevStep + 1);
                setEmptySelfie(false);
            } else {
                setEmptySelfie(true);
            }
            return;
        }

        setActiveStep((prevStep) => prevStep + 1);
        setEmptySelfie(false);
    };

    /**
     * handle for clean fields in employee
     */
    const handleClearEmployeeData = () => {
        setEmployeeData(prevState => ({
            id: prevState.id,
            departmentId: '',
            employeeId: '',
            startDate: null,
            endDate: null,
            roleId: '',
            zoneId: '',
        }));
    };

    /**
     * handle to open socket
     */
    const handleWebSocketOpen = () => {
        setIsSocketOpen(true);
    };

    /**
     * handle for received message of socket
     * @param event
     */
    const handleWebSocketMessage = (event) => {
        if (event.data === '') {
            return;
        }

        const message = JSON.parse(event.data);

        if (message.type === START_STREAM) {
            setLoadingProgress(false);
            const base64Image = message.base64;
            setSelfieSrc('');
            setVideoStreamSrc(`data:image/jpeg;base64,${base64Image}`);
        } else if (message.type === CREATE_PRINT_CARD) {
            if (message.base64 === 'SUCCESS') {
                toast.info(t('printing_for_more_details_check_the_print_queue'));
            }
        }
    };

    /**
     * handle to close socket
     * @param event
     */
    const handleWebSocketClose = (event) => {
        setIsSocketOpen(false);
        setCapturing(false);
    };

    /**
     * handle for get card
     */
    const printCard = () => {
        setSwitchSocket('printer');
        // Check if the WebSocket is already open
        if (websocketRef.current && websocketRef.current.readyState === WebSocket.OPEN) {
            // if (selectedReader !== '' && fingerprintSrc === '') {
            //     websocketRef.current.close();
            //     setSelectedReader('');
            // }
        } else {
            // Open a new WebSocket
            const newWebSocket = new WebSocket(wsURL);
            newWebSocket.onopen = handleWebSocketOpen;
            newWebSocket.onmessage = handleWebSocketMessage;
            newWebSocket.onclose = handleWebSocketClose;
            websocketRef.current = newWebSocket;
        }
    };

    /**
     * Resets the selected profile image to the default state.
     * Clears the preview image, temporary URL, and profile image reference.
     */
    const clearImage = () => {
        setPhotoPicker({...PHOTO_PICKER_MODEL, preview: defaultImage, id:null});
        setUrl2(null);
        setProfileImage(null);
    }

    /**
     * Deletes the user image from the backend by its ID.
     * On success, shows a confirmation message and triggers a UI update.
     *
     * @param {string} id - Unique identifier of the image to be deleted.
     */
    const handleDeleteImageApi = (id) => {
        const tableName = TABLES.USER_IMAGE;
        dispatch(HardDeleteRecordsByTableAndIds({ tableName, body: [id] })).then(({ payload: {data:{success, code}}}) => {
           if(success){
               toast.success(t('has_been_updated_successfully'));
               setUpdated(true);
           }else{
               errorMsg(code);
           }
        });
    }

    /**
     * Synchronizes the selected image source with local state variables.
     * Updates the image URL and profile image whenever the selected photo changes.
     */
    useEffect(() => {
        setUrl2(photoPicker?.srcSelected || null);
        setProfileImage(photoPicker?.srcSelected || null);
    }, [photoPicker?.srcSelected])

    return {
        t,
        navigate,
        disabled,
        contractorId,
        supplierId,
        permission,
        DEV,
        userType,
        headersList,
        employeeRoles,
        employeeWorkStations,
        contractStatusList,
        employeeDepartments,
        getUserRestriction,
        steps,
        activeStep,
        setActiveStep,
        loadingProgress, setLoadingProgress,
        imageToUpload, setImageToUpload,
        extraDataEnabled, setExtraDataEnabled,
        emptyFields, setEmptyFields,
        emptySelfie, setEmptySelfie,
        userData, setUserData,
        isValidEmail, setIsValidEmail,
        isValidPassword, setIsValidPassword,
        isValidDocumentId, setIsValidDocumentId,
        isValidPin,
        isValidPhoneNumber, setIsValidPhoneNumber,
        isValidDob, setIsValidDob,
        language, setLanguage,
        createEmployeeEmail, setCreateEmployeeEmail,
        extraData, setExtraData,
        employeeData, setEmployeeData,
        isValidStartDate, setIsValidStartDate,
        isValidEndDate, setIsValidEndDate,
        workShiftsList, setWorkShiftsList,
        customizedList, setCustomizedList,
        selectedReader, setSelectedReader,
        availableReaders, setAvailableReaders,
        capturedFingerprint, setCapturedFingerprint,
        fingerprintsList,
        fingerprintName, setFingerprintName,
        fingerprintSrc, setFingerprintSrc,
        updated, setUpdated,
        updatedFinger, setUpdatedFinger,
        capturing, setCapturing,
        videoStreamSrc, setVideoStreamSrc,
        selfieSrc, setSelfieSrc,
        availableCameras, setAvailableCameras,
        selectedCamera, setSelectedCamera,
        selectedImage, setSelectedImage,
        takeCamera, setTakeCamera,
        setCardData,
        cardDataInfo, setCardDataInfo,
        newCardModal, setNewCardModal,
        setIsAllChecked, isAllChecked,
        selectVehicleForDelete,setSelectVehicleForDelete,

        alldata, setAlldata,
        cardsList, setCardsList,
        documentsList, setDocumentsList,
        ProfileImage, setProfileImage,
        url2, setUrl2,
        showUnlinkBtn, setShowUnlinkBtn,
        role, setRole,
        workStation, setWorkStation,
        contractStatus, setContractStatus,
        vehicleData,
        vehicleId,
        deletePermitShow, setDeletePermitShow,
        vCardShow, setVCardShow,
        showPluginWarn, setShowPluginWarn,
        enqueueSnackbar, closeSnackbar,
        secretModal, setSecretModal,
        secretKey, setSecretKey,
        generatedPassword,
        setModified,
        photoPickerFile: photoPicker,
        setPhotoPickerFile: setPhotoPicker,
        isPilgrimsValidation,
        isSelfieValid,
        isValidCecoCode,
        handleValidationSelfie: () =>handleValidationSelfie(),
        handleCloseModal: () => handleCloseModal(),
        handleFormChangeUserData: (p) => handleFormChangeUserData(p),
        validatePhone: (p) => validatePhone(p),
        validateEmail: (e) => validateEmail(e),
        handleFormChangeExtraData: (e) => handleFormChangeExtraData(e),
        handleFormChangeEmployeeData: (e) => handleFormChangeEmployeeData(e),
        handleStepChange: (s) => handleStepChange(s),
        handleCreateEmployee: () => handleCreateEmployee(),
        handleUpdateEmployee : () => handleUpdateEmployee(),
        handleUploadSelfie : () => handleUploadSelfie(),
        handleClearExtraData: () => handleClearExtraData(),
        handleClearUserData: handleClearUserData,
        handleClearEmployeeData: handleClearEmployeeData,
        getAvailableReaders: () => getAvailableReaders(),
        handleUploadFinger: (id) => handleUploadFinger(id),
        handleValidationStepDetails: () => handleValidationStepDetails(),
        handleValidationContract: () => handleValidationContract(),
        handleValidationFinger: () => handleValidationFinger(),
        deleteSelectedPermits: () => deleteSelectedPermits(),
        handleDeleteAll: (e) => handleDeleteAll(e),
        handleCheckboxChangeVehicle : (e) =>handleCheckboxChangeVehicle(e),
        handleWebSocketOpen : (e) =>handleWebSocketOpen(e),
        handleWebSocketMessage : (e) =>handleWebSocketMessage(e),
        handleWebSocketClose : (e) =>handleWebSocketClose(e),
        printCard : (e) =>printCard(e),
        handleDeleteImage:clearImage,
    }

}



export default EmployeeApp;
